// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"87b0c955","348":"ad5620b3","352":"7d6131d2","613":"7abb8ff4"}[chunkId] + ".chunk.css";
};